import { createSlice } from "@reduxjs/toolkit";

export const ShowWaitingAndEventsModalSlice = createSlice({
    name: "showWaitingAndEventsModal",
    initialState: {
        showWaitingAndEventsModal : false,
    },
    reducers: {
        setShowWaitingAndEventsModal: (state, action) => {
            state.showWaitingAndEventsModal = action.payload;
        }
    }
})

export const { setShowWaitingAndEventsModal } = ShowWaitingAndEventsModalSlice.actions;

export default ShowWaitingAndEventsModalSlice.reducer;